import { render, staticRenderFns } from "./BookCourseAlert.vue?vue&type=template&id=678ef494&scoped=true"
import script from "./BookCourseAlert.vue?vue&type=script&lang=js"
export * from "./BookCourseAlert.vue?vue&type=script&lang=js"
import style0 from "./BookCourseAlert.vue?vue&type=style&index=0&id=678ef494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ef494",
  null
  
)

export default component.exports